"use client";
import { jsx as n, jsxs as b } from "react/jsx-runtime";
import i from "clsx";
import y from "next/image";
import { memo as s, forwardRef as v } from "react";
import N from "../../hooks/useHorizonalScroll.js";
import '../../assets/Base.css';const j = "_wrapper_knroh_1", M = "_size_920_knroh_11", z = "_size_1200_knroh_14", B = "_main_knroh_27", R = "_main_w_bg_knroh_40", S = "_main_bg_knroh_50", $ = "_box_knroh_78", D = "_gap_0_knroh_82", H = "_gap_2_knroh_85", T = "_gap_4_knroh_88", W = "_gap_8_knroh_91", L = "_gap_12_knroh_94", P = "_gap_16_knroh_97", E = "_gap_20_knroh_100", U = "_gap_24_knroh_103", q = "_gap_28_knroh_106", A = "_gap_32_knroh_109", C = "_gap_40_knroh_112", F = "__row_knroh_115", G = "__center_knroh_118", J = "__wide_knroh_122", K = "__fit_knroh_125", Q = "__justify_start_knroh_131", V = "__space_between_knroh_134", X = "__justify_end_knroh_137", Y = "__align_start_knroh_140", Z = "__align_center_knroh_143", I = "__align_end_knroh_146", O = "__wrap_knroh_149", __ = "_box_scrolled_wrapper_v_knroh_153", o_ = "__hide_scrollbar_knroh_162", n_ = "_box_scrolled_wrapper_x_knroh_191", e_ = "__masked_left_knroh_208", a_ = "__masked_right_knroh_211", r_ = "_box_scrolled_inner_x_knroh_218", s_ = "_pagination_dot_knroh_223", t_ = "__active_knroh_232", i_ = "__pointer_knroh_236", c_ = "_hr_knroh_240", _ = {
  wrapper: j,
  size_920: M,
  size_1200: z,
  main: B,
  main_w_bg: R,
  main_bg: S,
  box: $,
  gap_0: D,
  gap_2: H,
  gap_4: T,
  gap_8: W,
  gap_12: L,
  gap_16: P,
  gap_20: E,
  gap_24: U,
  gap_28: q,
  gap_32: A,
  gap_40: C,
  _row: F,
  _center: G,
  _wide: J,
  _fit: K,
  _justify_start: Q,
  _space_between: V,
  _justify_end: X,
  _align_start: Y,
  _align_center: Z,
  _align_end: I,
  _wrap: O,
  box_scrolled_wrapper_v: __,
  _hide_scrollbar: o_,
  box_scrolled_wrapper_x: n_,
  _masked_left: e_,
  _masked_right: a_,
  box_scrolled_inner_x: r_,
  pagination_dot: s_,
  _active: t_,
  _pointer: i_,
  hr: c_
}, p_ = s(
  ({ size: o = 920, className: e, children: a }) => /* @__PURE__ */ n("div", { className: i(_.wrapper, _["size_" + o], e), children: a })
);
p_.displayName = "Wrapper";
const l_ = s(
  ({ background: o, metaBg: e = "", children: a }) => /* @__PURE__ */ b("main", { className: i(_.main, { [_.main_w_bg]: o }), children: [
    o && /* @__PURE__ */ n("div", { className: _.main_bg, children: /* @__PURE__ */ n(y, { src: o, alt: e }) }),
    a
  ] })
);
l_.displayName = "Main";
const g_ = ({
  gap: o = 20,
  row: e,
  center: a,
  wide: c,
  fit: t,
  justify_start: p,
  space_between: h,
  justify_end: d,
  align_start: m,
  align_center: k,
  align_end: l,
  wrap: x,
  className: w,
  children: g,
  ...f
}, u) => /* @__PURE__ */ n(
  "div",
  {
    className: i(
      _.box,
      _["gap_" + o],
      {
        [_._row]: e,
        [_._center]: a,
        [_._wide]: c,
        [_._fit]: t,
        [_._justify_start]: p,
        [_._space_between]: h,
        [_._justify_end]: d,
        [_._align_start]: m,
        [_._align_center]: k,
        [_._align_end]: l,
        [_._wrap]: x
      },
      w
    ),
    ref: u,
    ...f,
    children: g
  }
), r = s(
  v(g_)
);
r.displayName = "Box";
const h_ = s(
  ({
    children: o,
    direction: e,
    hideScrollbar: a,
    offsetOut: c = 0,
    offsetIn: t = 0,
    ...p
  }) => {
    const {
      wrapRef: h,
      innerRef: d,
      maskLeft: m,
      maskRight: k,
      handlerChangeMask: l,
      onMouseStart: x,
      onMouseMove: w,
      onSwipeEnd: g
    } = N(c);
    return e === "vertical" ? /* @__PURE__ */ n(
      r,
      {
        wide: !0,
        className: i(_.box_scrolled_wrapper_v, {
          [_._hide_scrollbar]: a
        }),
        style: {
          "--offset-out": `${c}px`,
          "--offset-in": `${t}px`
        },
        children: /* @__PURE__ */ n(r, { className: _.box_scrolled_inner_v, ...p, children: o })
      }
    ) : /* @__PURE__ */ n(
      r,
      {
        className: i(_.box_scrolled_wrapper_x, {
          [_._masked_left]: m && t,
          [_._masked_right]: k && t
        }),
        ref: h,
        style: {
          "--offset-out": `${c}px`,
          "--offset-in": `${t}px`
        },
        children: /* @__PURE__ */ n(
          r,
          {
            row: !0,
            className: _.box_scrolled_inner_x,
            ref: d,
            onTouchMove: l,
            onWheel: l,
            onMouseDown: x,
            onMouseMove: w,
            onMouseUp: g,
            onMouseLeave: g,
            ...p,
            children: o
          }
        )
      }
    );
  }
);
h_.displayName = "BoxScrolled";
const d_ = s(({ children: o }) => /* @__PURE__ */ n(r, { gap: 8, children: o }));
d_.displayName = "TitleBox";
const m_ = s(
  ({ active: o, onClick: e }) => /* @__PURE__ */ n(
    "div",
    {
      "aria-label": "Scroll to slide",
      className: i(_.pagination_dot, {
        [_._active]: o,
        [_._pointer]: e
      }),
      onClick: e
    }
  )
);
m_.displayName = "PaginationDot";
const k_ = s(({ text: o }) => /* @__PURE__ */ b(r, { gap: 12, row: !0, center: !0, className: _.hr, children: [
  /* @__PURE__ */ n("hr", {}),
  o,
  /* @__PURE__ */ n("hr", {})
] }));
k_.displayName = "HR";
export {
  r as Box,
  h_ as BoxScrolled,
  k_ as HR,
  l_ as Main,
  m_ as PaginationDot,
  d_ as TitleBox,
  p_ as Wrapper
};
